
export default {
  UslugeZaIspit: [],
  OdabranaUsluga: null
}



// WEBPACK FOOTER //
// ./VueSrc/Common/Store/Exams/Exam_state.js